import apiSlice from "./ApiSlice";

export const modeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get Mode Filter Pagination List
    getModePagination: builder.query({
      providesTags: ["mode"],
      query: (body) => {
        return {
          url: "/mode",
          method: "POST",
          body,
        };
      },
    }),

    // Add
    addMode: builder.mutation({
      invalidatesTags: ["mode"],
      query: (body) => {
        return {
          url: "/mode/add",
          method: "POST",
          body,
        };
      },
    }),

    // Delete
    deleteMode: builder.mutation({ 
        invalidatesTags: ["mode"],
      query: (id:string) => {
        return {
          url: `/mode/${id}`,
          method: 'DELETE',
        };
      },
    }),
   //Edit
   editMode: builder.mutation({
    invalidatesTags: ["mode"],
     query: ({body ,id}:any) => {
      return {
        url: `/mode/${id}`,
        method: "PUT",
        body,
      };
    },
  }),
  //Single View
  viewMode: builder.query({
    providesTags: ["mode"],
     query: (id:any) => {
      return {
        url: `/mode/${id}`,
        method: "GET",
      };
    },
  }),
  }),
});

export const { useGetModePaginationQuery, useAddModeMutation , useDeleteModeMutation , useEditModeMutation , useViewModeQuery } = modeApi;
